import { atom, useAtomValue, useSetAtom } from 'jotai';

/**
 * Base atom holding selected invoice IDs
 */
const spicyInvoiceSelectionAtom = atom<string[]>([]);

const hoveredInvoiceIdsAtom = atom<string[]>([]);

const isInvoiceHighlightedAtom = atom(
  get => (invoiceId: string) => get(hoveredInvoiceIdsAtom).includes(invoiceId),
);

/**
 * Hook
 */
export function useInvoiceSelection() {
  const selectedInvoiceIds = useAtomValue(spicyInvoiceSelectionAtom);
  const initializeSelectedIds = useSetAtom(spicyInvoiceSelectionAtom);
  const setHoveredInvoiceIds = useSetAtom(hoveredInvoiceIdsAtom);
  const isInvoiceHighlighted = useAtomValue(isInvoiceHighlightedAtom);

  return {
    selectedInvoiceIds,
    initializeSelectedIds,
    setHoveredInvoiceIds,
    isInvoiceHighlighted,
  };
}
